export * from './DetailLink'
